import React, { PureComponent } from 'react';
import Loader from 'react-loader-spinner';
import PropTypes from 'prop-types';

class OwnLoader extends PureComponent {
  timer = 0;

  state = {
    delay: this.props.delay,
    showSpinner: false,
  };

  componentDidMount() {
    const { delay } = this.state;

    this.timer = window.setTimeout(() => this.setState({ showSpinner: true }), delay);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    const { showSpinner } = this.state;

    if (!showSpinner) {
      return null;
    }

    return (
      <Loader
        type="Watch"
        color="#19afcb"
        height={100}
        width={100}
        className="text-center py-5"
      />
    );
  }
}

OwnLoader.defaultProps = {
  delay: 300,
};

OwnLoader.propTypes = {
  delay: PropTypes.number,
};

export default OwnLoader;
